import { FunctionComponent as F, memo } from "react";
import { IState } from "../../core/store/store";
import ProtocolListItem from "./ProtocolListItem";
import { useSelector } from 'react-redux';
import { Box, ListSubheader } from "@mui/material";


interface Props
{
  drawerOpen: boolean
}


const SharedWithMe: F<Props> = memo((props: Props) =>
{
  const user = useSelector((state: IState) => state.user);
  const protocols = useSelector((state: IState) => state.protocol.protocols
    .filter(p => p.sharedWith.filter(u => u.userId === user.userId).length));

  return (
    <>
      {protocols.length ?
        <ListSubheader component="div">
          {"Shared with me"}
        </ListSubheader> :
        <></>}
      <Box sx={{ pl: 1, pr: 1 }}>
        {protocols
          .map((p, i) => <ProtocolListItem key={i} protocolId={p.protocolId} drawerOpen={props.drawerOpen}/>)}
      </Box>
    </>);
})

export default SharedWithMe;